import { FC } from 'react';

// Components
import { RankingTableCell } from './RankingTableCell';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

// Types
import { INormalizedTennisRankingRow } from '../../../types';

interface Props {
  rows: INormalizedTennisRankingRow[] | undefined;
  handleParticipantClick: (id: string | number, name: string) => void;
}

export const RankingTableBody: FC<Props> = ({ rows, handleParticipantClick }) => {
  return (
    <tbody className='ranking-table-body'>
      {rows?.map((row) => (
        <RankingTableCell key={row.athlete.id} row={row} handleParticipantClick={handleParticipantClick} />
      ))}
    </tbody>
  );
};
